import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

/**
 * Lookup table tipos_documento (vocabulario controlado, Principio 5 EN).
 */
export const useTiposDocumento = () => {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from('tipos_documento')
        .select('value, label_pt')
        .eq('is_active', true)
        .order('display_order');
      if (!cancelled) {
        setTipos(data || []);
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { tipos, loading };
};
